import { render, staticRenderFns } from "./TheSettingsSingleLink.vue?vue&type=template&id=1b8709ac&scoped=true&"
import script from "./TheSettingsSingleLink.vue?vue&type=script&lang=js&"
export * from "./TheSettingsSingleLink.vue?vue&type=script&lang=js&"
import style0 from "./TheSettingsSingleLink.vue?vue&type=style&index=0&id=1b8709ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8709ac",
  null
  
)

export default component.exports